import { apiClient } from "rp-components"

export interface DraftInvoiceResponse {
    setupIntentId: string
    setupIntentSecret: string
    accountId: string
    ephemeralKey: string
    customerId: string
    publishableKey: string
}

export interface SubmitOrderResponse {
    orderId: string
    status: string
}

export interface PaymentService {
    draftInvoice(orderId: string): Promise<DraftInvoiceResponse>
    refreshPayment(orderId: string): Promise<DraftInvoiceResponse>
    capturePaymentMethod(orderId: string): Promise<void>
    submitOrder(orderId: string): Promise<SubmitOrderResponse>
}

class PaymentServiceImpl implements PaymentService {
    static instance?: PaymentService = undefined

    private constructor() {}

    static getInstance(): PaymentService {
        if (PaymentServiceImpl.instance == undefined) {
            PaymentServiceImpl.instance = new PaymentServiceImpl()
        }
        return PaymentServiceImpl.instance
    }

    async draftInvoice(orderId: string): Promise<DraftInvoiceResponse> {
        return apiClient.post<DraftInvoiceResponse, Record<string, never>>(`orders/${orderId}/draft-invoice`, {})
    }

    async refreshPayment(orderId: string): Promise<DraftInvoiceResponse> {
        return apiClient.get<DraftInvoiceResponse>(`orders/${orderId}/refresh-payment`)
    }

    async capturePaymentMethod(orderId: string): Promise<void> {
        return apiClient.post<void, Record<string, never>>(`orders/${orderId}/capture-payment-method`, {})
    }

    async submitOrder(orderId: string): Promise<SubmitOrderResponse> {
        return apiClient.post<SubmitOrderResponse, Record<string, never>>(`orders/${orderId}/submit`, {})
    }
}

export default PaymentServiceImpl.getInstance()
